import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {PartnerProduct} from "../../models/partner-product.model";

@Component({
  selector: 'app-vet-planet-category-product-modal',
  templateUrl: './vet-planet-category-product-modal.component.html',
  styleUrls: ['./vet-planet-category-product-modal.component.scss'],
})
export class VetPlanetCategoryProductModalComponent implements OnInit {

  constructor(private modalController: ModalController) { }

  @Input() productsInCart: Set<PartnerProduct>;
  @Input() products: PartnerProduct[];
  @Input() categoryTags: string[];
  category: string;
  innerCategory: string;
  ngOnInit() {
    this.category = this.categoryTags[1];
    this.innerCategory = this.categoryTags[2];
  }

  dismiss() {
    this.modalController.dismiss();
  }

  onAddToCartToggleChange(product: PartnerProduct) {

    if (!this.productsInCart.has(product)) {
      this.productsInCart.add(product);
    } else {
      this.productsInCart.delete(product);
    }

  }

  addedToCart(product: PartnerProduct) {
    return this.productsInCart.has(product);
  }
}
